<template>
  <a-tabs style="width: 100%;background: white;padding: 20px;box-sizing: border-box;height: 100%">
    <a-tab-pane key="1" tab="员工认证">
      <EnterpriseVerification></EnterpriseVerification>
    </a-tab-pane>
    <a-tab-pane key="2" tab="员工优惠">
      <EmployeeBenefit></EmployeeBenefit>
    </a-tab-pane>
    <a-tab-pane key="3" tab="详情访问控制">
      <EmployeeSetting></EmployeeSetting>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import EmployeeSetting from '@/views/platform/employeeVerification/components/EmployeeSetting.vue'
import EmployeeBenefit from '@/views/platform/employeeVerification/components/EmployeeBenefit.vue'
import EnterpriseVerification from '@/views/platform/employeeVerification/components/EnterpriseVerification.vue'

export default {
  name: 'VerificationList',
  mixins: [searchForm],
  components: {
    EnterpriseVerification: EnterpriseVerification,
    EmployeeBenefit: EmployeeBenefit,
    EmployeeSetting: EmployeeSetting
  },
  data() {
    return {}
  },

  methods: {}
}
</script>
<style scoped lang="less">

</style>